import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { VoyaSSO } from '../models/voya';

const controllerRoute = '/voyaeoi';

@Injectable()
export class VoyaService {

    constructor(
        private apiService: ApiService,
    ) {
    }

    public getVoyaSSO(): Observable<VoyaSSO> {
        return this.apiService.post(`${controllerRoute}/signontovoyaeoiresult`, null).pipe(
            map((response: VoyaSSO) => {
                return response;
            }),
        );
    }
}